const REFRESH_TOKEN_PENDING = "AUTH_REFRESH_TOKEN_PENDING";
const REFRESH_TOKEN_SUCCESS = "AUTH_REFRESH_TOKEN_SUCCESS";
const REFRESH_TOKEN_ERROR = "AUTH_REFRESH_TOKEN_ERROR";
const REFRESH_TOKEN_SET_USER_INFO = "AUTH_REFRESH_TOKEN_SET_USER_INFO";
const CHANGE_LANGUAGE = "AUTH_CHANGE_LANGUAGE";

export default {
  REFRESH_TOKEN_PENDING,
  REFRESH_TOKEN_SUCCESS,
  REFRESH_TOKEN_ERROR,
  REFRESH_TOKEN_SET_USER_INFO,
  CHANGE_LANGUAGE,
};
